import React from 'react';

export enum DPNConsentType {
  INFO = 'INFO',
  CHECKBOX = 'CHECKBOX',
}

export interface DPNItem {
  code: string;
  company: number;
  dpnId: number;
  type: DPNConsentType;
  isAdmin: boolean;
  locale: string;
  optional: boolean;
  sequence: number;
  text: string;
  version: number;
  isSelected: boolean;
}

export interface DPNResponse {
  dpnOptionsDTO: DPNItem[];
  adm: number;
  dpnId: number;
  dpnUrl: string;
  isScoreReused: boolean;
  isVideoInterview: boolean;
  videoDpnId: number;
  isgdpr: boolean;
  tpurlc: string;
  ddm: number;
  isIntegrated: boolean;
  company: number;
  projectId: number;
  dataProtectionNoticeText?: string;
  dataProtectionNoticeMetaData?: DPNItem[];
}

export interface DPNContentProps {
  isIntegrated: boolean | null;
  ddm: number | null;
  adm: number | null;
  url: string | null;
  isDpnLoaded: (isLoaded: boolean) => void;
  setCollapsed?: () => void;
  tcPlusDpnHtml?: string | null;
}

export interface SaveProcessDPNData {
  agreedForContact: boolean;
  dpnId: number;
}

export interface SaveProcessDPNDataResponse {
  errorCode: number;
  errorMessage: string;
  successMessage: string;
  redirect: boolean;
  sessionTimeOutTime: number;
  successCode: number;
  triggerNext: boolean;
  viewName: string;
}

export interface DpnLayoutProps {
  isDpnProcessing: boolean;
  dpnOptions: DPNItem[] | undefined;
  dpnData: DPNResponse | null;
  isDpnLoaded: (isLoaded: boolean) => void;
  isDpnContentLoaded: string;
  setDpnOptions: React.Dispatch<React.SetStateAction<DPNItem[] | undefined>>;
  handleDPNAcceptance: (event: React.SyntheticEvent) => Promise<void>;
}
